<template>
  <section>
    <Hero>
      <strong>Вдохновленные вызовом</strong>,
      <br>создаем  <em>удивительные&nbsp;</em><em>&nbsp;продукты!</em>
    </Hero>
    <ProjectsList />
  </section>
</template>

<script>
import Hero from 'components/Hero';

const ProjectsList = () => import('components/ProjectsList');

export default {
  name: 'Projects',
  components: {
    Hero,
    ProjectsList,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Projects.vue